import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Navbar.css';
import logo1 from '../../assets/contactBlogCareer/header2-logo.webp';
import logo2 from '../../assets/contactBlogCareer/oakya-it-services.webp';

const Navbar = ({ onLogoClick }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeLink, setActiveLink] = useState('');
  const [activeService, setActiveService] = useState('');
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [isMobileServicesOpen, setIsMobileServicesOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const services = [
    { name: 'Software Development', path: '/software-development', key: 'softwaredevelopment' },
    { name: 'Mobile App Development', path: '/mobile-development', key: 'mobiledevelopment' },
    { name: 'E-commerce Development', path: '/ecommerce-development', key: 'ecommercedevelopment' },
    { name: 'Website Development', path: '/website-development', key: 'websitedevelopment' },
    { name: 'Digital Marketing', path: '/digital-marketing', key: 'digitalmarketing' },
    { name: 'Branding', path: '/branding', key: 'branding' },
    { name: '3D-Animations', path: '/3danimations', key: '3danimations' },
    { name: 'Educational Consultancy', path: '/educational-consultancy', key: 'educationalconsultancy' },
  ];

  useEffect(() => {
    const currentPath = location.pathname;

    if (currentPath === '/') {
      setActiveLink('home');
      setActiveService('');
    } else if (currentPath.includes('/about')) {
      setActiveLink('about');
      setActiveService('');
    } else if (currentPath.includes('/portfolio')) {
      setActiveLink('portfolio');
      setActiveService('');
    } else if (currentPath.includes('/expertise')) {
      setActiveLink('expertise');
      setActiveService('');
    } else if (currentPath.includes('/contact')) {
      setActiveLink('contact');
      setActiveService('');
    } else if (currentPath.includes('/career')) {
      setActiveLink('career');
      setActiveService('');
    } else if (currentPath.includes('/our-blog')) {
      setActiveLink('blog');
      setActiveService('');
    } else if (
      currentPath.includes('/services') ||
      services.some(s => currentPath.includes(s.path))
    ) {
      setActiveLink('services');
      const foundService = services.find(s => currentPath.includes(s.path));
      setActiveService(foundService ? foundService.key : '');
    }
  }, [location.pathname]);

  const handleLogoClick = (e) => {
    e.preventDefault();
    window.scrollTo({
  top: 0,
  left: 0,
  behavior: "smooth",
});
    if (location.pathname === '/') {
      if (onLogoClick) onLogoClick();
    } else {
      navigate('/');
    }
  };

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setIsMobileServicesOpen(false);
  };
  const toggleMobileServices = () => setIsMobileServicesOpen(!isMobileServicesOpen);

const handleLinkClick = (link) => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  setActiveLink(link);
  setActiveService('');
  closeMobileMenu();
};

const handleServiceClick = (serviceKey) => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });

  setActiveLink('services');
  setActiveService(serviceKey);
  closeMobileMenu();
  setIsServicesOpen(false);
};


  return (
    <>
      <header className="navbar">
        {/* Logo Element */}
        <div className="logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
          <img src={logo1} alt="Desktop Logo" className="logo-desktop" loading="lazy" />
          <img src={logo2} alt="Mobile Logo" className="logo-mobile" loading="lazy" />
        </div>

        {/* Burger Button */}
        <div className="hamburger" onClick={toggleMobileMenu}>
          ☰
        </div>

        {/* Desktop Links Viewport */}
        <nav className="nav-links">
          <Link to="/" className={activeLink === 'home' ? 'active' : ''} onClick={() => handleLinkClick('home')}>
            Home
          </Link>
          <Link to="/about" className={activeLink === 'about' ? 'active' : ''} onClick={() => handleLinkClick('about')}>
            About Us
          </Link>

          {/* Service Menu Container */}
          <div
            className="dropdown"
            onMouseEnter={() => setIsServicesOpen(true)}
            onMouseLeave={(e) => {
              const target = e.relatedTarget;
              if (!target || !(target instanceof Node) || !e.currentTarget.contains(target)) {
                setIsServicesOpen(false);
              }
            }}
          >
            <div className={`dropdown-wrapper ${activeLink === 'services' ? 'active' : ''}`}>
              <button className={`dropbtn ${activeLink === 'services' ? 'active' : ''}`}>
                Services <span className="arrow-indicator">▾</span>
              </button>
            </div>
            <div className={`dropdown-content ${isServicesOpen ? 'show' : ''}`}>
              {services.map((service, index) => (
                <Link
                  key={index}
                  to={service.path}
                  className={activeService === service.key ? 'active-sub' : ''}
                  onClick={() => handleServiceClick(service.key)}
                >
                  {service.name}
                </Link>
              ))}
            </div>
          </div>

          <Link to="/expertise" className={activeLink === 'expertise' ? 'active' : ''} onClick={() => handleLinkClick('expertise')}>
            Expertise
          </Link>
          <Link to="/portfolio" className={activeLink === 'portfolio' ? 'active' : ''} onClick={() => handleLinkClick('portfolio')}>
            Portfolio
          </Link>
          <Link to="/career" className={activeLink === 'career' ? 'active' : ''} onClick={() => handleLinkClick('career')}>
            Careers
          </Link>
          <Link to="/our-blog" className={activeLink === 'blog' ? 'active' : ''} onClick={() => handleLinkClick('blog')}>
            Our Blog
          </Link>
          <Link to="/contact" className={activeLink === 'contact' ? 'active' : ''} onClick={() => handleLinkClick('contact')}>
            Contact
          </Link>

          {/* Action CTA Button */}
          <Link to="/contact" className="lets-talk-btn" onClick={() => handleLinkClick('contact')}>
            Let's Talk <span className="lets-talk-arrow">›</span>
          </Link>
        </nav>
      </header>

      {/* Slide Drawer Side Menu */}
      <aside className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
        <button className="mobile-close" onClick={closeMobileMenu}>✕</button>
        <ul className="mobile-nav">
          <li>
            <Link to="/" className={activeLink === 'home' ? 'active' : ''} onClick={() => handleLinkClick('home')}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/about" className={activeLink === 'about' ? 'active' : ''} onClick={() => handleLinkClick('about')}>
              About Us
            </Link>
          </li>
          <li className="mobile-services-item">
            <button
              className={`mobile-toggle ${activeLink === 'services' ? 'active' : ''}`}
              onClick={toggleMobileServices}
            >
              Services {isMobileServicesOpen ? '▴' : '▾'}
            </button>
            <ul className={`mobile-sub ${isMobileServicesOpen ? 'open' : ''}`}>
              {services.map((service, index) => (
                <li key={index}>
                  <Link
                    to={service.path}
                    className={activeService === service.key ? 'active-sub' : ''}
                    onClick={() => handleServiceClick(service.key)}
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </li>
          <li>
            <Link to="/expertise" className={activeLink === 'expertise' ? 'active' : ''} onClick={() => handleLinkClick('expertise')}>
              Expertise
            </Link>
          </li>
          <li>
            <Link to="/portfolio" className={activeLink === 'portfolio' ? 'active' : ''} onClick={() => handleLinkClick('portfolio')}>
              Portfolio
            </Link>
          </li>
          <li>
            <Link to="/career" className={activeLink === 'career' ? 'active' : ''} onClick={() => handleLinkClick('career')}>
              Careers
            </Link>
          </li>
          <li>
            <Link to="/our-blog" className={activeLink === 'blog' ? 'active' : ''} onClick={() => handleLinkClick('blog')}>
              Our Blog
            </Link>
          </li>
          <li>
            <Link to="/contact" className={activeLink === 'contact' ? 'active' : ''} onClick={() => handleLinkClick('contact')}>
              Contact
            </Link>
          </li>
          <li>
            <Link to="/contact" className="mobile-lets-talk" onClick={() => handleLinkClick('contact')}>
              Let's Talk <span className="lets-talk-arrow">›</span>
            </Link>
          </li>
        </ul>
      </aside>

      {/* Background Mask Screen Element */}
      <div className={`overlay ${isMobileMenuOpen ? 'open' : ''}`} onClick={closeMobileMenu}></div>
    </>
  );
};

export default Navbar;